import { Auth } from "../src/api/Auth";
import { ContentManager } from "../src/helpers/ContentManager";
import { Api } from "../src/api/Api";
import { GetDataHelper } from "../src/helpers/GetDataHelper";
import { initInterface } from "../src/initInterface";
import { setAuthRegButtonListeners } from "../src/listners/setAuthRegButtonListeners";
import { initGlobalStore } from "../src/store";
import { setCityFiltersListners } from "../src/listners/setCityFiltersListners";
import { resolveTopBar } from "../src/functions/resolveTopBar";
import $ from "jquery";
import { setCityChangeListener } from "../src/listners/setCityChangeListener";

window.content = new ContentManager();
window.auth = new Auth();
window.DataHelper = new GetDataHelper();
window.api = new Api();

// initInterface();
initGlobalStore();

setAuthRegButtonListeners(setPage);

function main() {
  Promise.all([api.getUserProfile(), api.getUsersBonusBalance()]).then(() => {
    content.setProfileHeader(DataHelper.store.user, DataHelper.store.bonuses);
    content.hideModalWindows(false);
  })
    .catch(error => console.log("error on auth check: ", error))
    .finally(() => {
      setPage();
    });
}


function setPage() {
  resolveTopBar().then(({ restaurants, baseCity }) => {
    content.setRestaurantsContent(restaurants);
    
    api.getCities().then(({ cities }) => {
      setCityFiltersListners(cities);
    })

    $("#topBarReservationButton").on("click", (e) => {
      const city = JSON.parse(localStorage.getItem('currentCity')) || baseCity;
      const currentCityRestaurants = restaurants.filter(r =>
        r.city_uuid === city.uuid);
      content.setReservationRestaurantsField(currentCityRestaurants)
    })
  });
}

main();
